<template>
	<div>
		<the-navigation />
		<v-content>
			<v-container class="fill-height" fluid>
				<child />
			</v-container>
		</v-content>
	</div>
</template>

<script>
import TheNavigation from '~/components/TheNavigation'
export default {
	name: 'AppLayout',

	components: { TheNavigation }
}
</script>
